import { useRef } from 'react';
import { useField, notEmptyString, lengthLessThan } from '@shopify/react-form';
import useModalState from '@sdk/components/ui/modal/useModalState';
import gettext from '@sdk/lang/gettext';

export const useDenyButton = (deny: (reason: string) => Promise<void>) => {
  const promiseRef = useRef(null);
  const resolveRef = useRef(null);
  const rejectRef = useRef(null);

  const { isVisible, open, close } = useModalState();
  const reasonField = useField<string>({
    value: '',
    validates: [
      notEmptyString(gettext('Reason is required')),
      lengthLessThan(161, gettext('Use maximum of 160 characters')),
    ],
  });
  const isInvalidReason = Boolean(reasonField.error?.length);

  const openDenyModal = () => {
    promiseRef.current = new Promise((resolve, reject) => {
      resolveRef.current = resolve;
      rejectRef.current = reject;
      open();
    });
    return promiseRef.current;
  };

  const onDismiss = () => {
    rejectRef.current();
    close();
  };

  const onDeny = async () => {
    close();
    try {
      await deny(reasonField.value);
      resolveRef.current();
    } catch (e) {
      rejectRef.current();
    } finally {
      reasonField.onChange('');
    }
  };

  return {
    isVisible,
    reasonField,
    isInvalidReason,
    openDenyModal,
    onDismiss,
    onDeny,
  };
};
